module.exports = __webpack_public_path__ + "img/bingo_ball-43.187244a2.png";